import * as React from 'react';
import { Provider } from 'react-redux';
import { Router, browserHistory, createMemoryHistory } from 'react-router';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import { makeRoutes } from './routes';
import configureStore from './store/configureStore';
import { isBrowser } from './utils';
import { debug } from '../utils';
import './styles.less';
//import './manifest.json';

const log = debug('Root');
import { loadState, saveState } from './models'

export const history = isBrowser ? browserHistory : createMemoryHistory();
export const store = configureStore({
    initialState: {
		...((window as any).__INITIAL_STATE__),
		    ...(loadState())},
    middleware: [routerMiddleware(history)]
}); // eslint-disable-line

const reduxHistory = syncHistoryWithStore(history, store);
store.subscribe(() => saveState(store.getState()));

const RootEnv = (__DEV__
							 ? require('./containers/DevTools/DevTools').default
							 : () => (<span />)) as any;
const DevTools = () => (<Provider store={store} ><RootEnv /></Provider>);

import { calculateResponsiveState } from 'redux-responsive';
function initializeResponsiveState() {
  store.dispatch(calculateResponsiveState(window));
}
export { DevTools, initializeResponsiveState };

export default class Root extends React.Component<any,any> {
		render() {
				return (
						<Provider store={store}>
								<Router history={reduxHistory} routes={makeRoutes()} />
						</Provider>
				);
		}
}



// WEBPACK FOOTER //
// ./src/app/Root.tsx